export default {"src":"/_next/static/media/0x4a717522566c7a09fd2774ccedc5a8c43c5f9fd2.7344927a.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};